import clsx from 'clsx'
import React, {memo, useCallback, useState} from 'react'

import {AccordionContext} from './AccordionContext'
import * as classes from './classes'
import type {Props} from './types'

const Accordion = memo<Props>(({'data-testid': dataTestId, children, className, defaultValue = false, expandBy = 'summary'}) => {
  const [isExpanded, setIsExpanded] = useState(defaultValue)

  const toggle = useCallback(() => {
    setIsExpanded(prev => !prev)
  }, [setIsExpanded])

  return (
    <AccordionContext.Provider value={{isExpanded, toggle, expandBy}}>
      <div className={clsx(classes.root, className)} data-testid={dataTestId}>{children}</div>
    </AccordionContext.Provider>
  )
})

Accordion.displayName = 'Accordion'

export {Accordion}
